<template lang="pug">
  //- фильтр
  #search
    input.text(type="text" placeholder="Поиск..." v-model="searchString" v-on:keyup="dropdown"  v-on:keyup.enter="filter")
    md-button.small.md-icon-button.close.md-dense.md-accent(@click="breakFilter" v-if="searchString.length"): md-icon close
    md-menu(md-size="auto" md-direction="top-start" md-align-trigger)
      md-button.md-icon-button.md-dense.md-primary(md-menu-trigger): md-icon settings
      md-menu-content.search-md-menu-container
        div.freight-filter
          label Дата отправления
          div.md-layout.md-gutter
            div.md-layout-item.md-small-size-100
              md-field(v-bind:class="((departureFrom) ? 'md-has-value' : '')")
                label От
                datetime(name="departureFrom" v-model="departureFrom" input-class="md-input" type="date" v-bind:week-start="1" v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }")
            div.md-layout-item.md-small-size-100
              md-field(v-bind:class="((departureTo) ? 'md-has-value' : '')")
                label До
                datetime(name="departureTo" v-model="departureTo" input-class="md-input" type="date" v-bind:week-start="1" v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }")
          div
            md-field
              label Статус
              md-select(v-model="status")
                md-option(value="all") Любой
                md-option(v-for="status in trackingStatuses" v-bind:value="status.id" v-bind:key="status.id") {{ status.name }}
            md-field
              label Склад
              md-select(v-model="stock")
                md-option(value="all") Все
                md-option(v-for="stock in stocks" v-bind:value="stock.id" v-bind:key="stock.id") {{ stock.name }}
            md-field
              label Экспедирование в точке забора
              md-select(v-model="forwardingFrom")
                md-option(value="all") Все
                md-option(value="no") Не требуется
                md-option(value="yes") Требуется
            md-field
              label Экспедирование в точке выдачи
              md-select(v-model="forwardingTo")
                md-option(value="all") Все
                md-option(value="no") Не требуется
                md-option(value="yes") Требуется
          md-button.md-primary(v-on:click="breakFilter") Сбросить фильтр
    ul.dropdown.md-elevation-2(v-if="showSearchDropdown && searchString")
      li(@click="filter" v-for="freight in freights") Груз #[md-chip {{freight.traking_number}}]
</template>

<script>
import moment from "moment"
import ToggleMenu from '@/components/ToggleMenu'
  export default {
    components: {ToggleMenu},
    data() {
      return {
        status: 'all',
        stock: 'all',
        forwardingFrom: 'all',
        forwardingTo: 'all',
        departureFrom: 'all',
        departureTo: 'all',
        searchString: '',
        showSearchDropdown: false,
        //freights: [],
        searchFreight: [],
        forwardingsFrom: [{id: 1, name: 'Требуется'}],
        forwardingsTo:   [{id: 1, name: 'Требуется'}]
      }
    },
    watch: {
      'status'(newVal) {
        this.changeStatusFilter();
      },
      'stock'(newVal) {
        this.changeStockFilter();
      },
      'forwardingFrom'(newVal) {
        this.changeForwardingFilterFrom();
      },
      'forwardingTo'(newVal) {
        this.changeForwardingFilterTo();
      },
      'departureFrom'(val) {
        if (val) this.changeDepartureFilter();
      },
      'departureTo'(val) {
        if (val) this.changeDepartureFilter();
      }
    },
    computed: {
      freightAmount() {
        return this.$store.state.stock.freights_amount;
      },
      totalPages() {
        return Math.ceil(this.freightAmount / this.perPage);
      },
      statuses() {
        return this.$store.state.stock.freight_statuses
      },
      users() {
        return this.$store.state.users.users
      },
      trackingStatuses() {
        return this.$store.state.stock.freight_statuses;
      },
      freights() {
        return this.$store.state.stock.freightsSearch;
      },
      stocks() {
        return this.$store.state.stock.stocks;
      }
    },
    methods: {
      breakFilter() {
        this.$cookie.set('filterFreightByStock',          'all', { expires: '1M' });
        this.$cookie.set('filterFreightByStatus',         'all', { expires: '1M' });
        this.$cookie.set('filterFreightByForwardingFrom', 'all', { expires: '1M' });
        this.$cookie.set('filterFreightByForwardingTo',   'all', { expires: '1M' });
        this.$cookie.set('filterFreightByDepartureFrom',  'all', { expires: '1M' });
        this.$cookie.set('filterFreightByDepartureTo',    'all', { expires: '1M' });

        this.status = 'all';
        this.stock  = 'all';
        this.forwardingFrom = 'all';
        this.forwardingTo   = 'all';
        this.departureFrom  = 'all';
        this.departureTo    = 'all';
        //this.$root.$emit('reload-table', 'freights');

        this.showSearchDropdown = false;
        this.searchString = '';
        //this.$router.push({name: this.$route.name, params: this.$route.params, query: {}});
          this.$router.replace({name: this.$route.name, params: this.$route.params, query: {}});
          this.$root.$emit('reload-table', 'freights');
      },
      changeStockFilter() {
        this.$cookie.set('filterFreightByStock', this.stock, { expires: '1M' });
        this.$nextTick(() => this.$root.$emit('reload-table', 'freights'));
      },
      //сохранение фильтра по статусу
      changeStatusFilter() {
        this.$cookie.set('filterFreightByStatus', this.status, { expires: '1M' });
        this.$nextTick(() => this.$root.$emit('reload-table', 'freights'));
      },
      changeForwardingFilterFrom() {
        this.$cookie.set('filterFreightByForwardingFrom', this.forwardingFrom, { expires: '1M' });
        this.$nextTick(() => this.$root.$emit('reload-table', 'freights'));
      },
      changeForwardingFilterTo() {
        this.$cookie.set('filterFreightByForwardingTo', this.forwardingTo, { expires: '1M' });
        this.$nextTick(() => this.$root.$emit('reload-table', 'freights'));
      },
      changeDepartureFilter() {
        this.$cookie.set('filterFreightByDepartureFrom', this.departureFrom, { expires: '1M' });
        this.$cookie.set('filterFreightByDepartureTo', this.departureTo, { expires: '1M' });
        this.$nextTick(() => this.$root.$emit('reload-table', 'freights'));
      },
      dropdown() {
        this.showSearchDropdown = true;
        let filter = {
          model: [
            ['id','=', this.searchString],
            'or',
            ['traking_number','%', this.searchString],
            'or',
            ['description','%', this.searchString],
          ],
          relation: []
        };
        this.$store.dispatch('stock/searchFreights', { filter: filter });
      },
      filter() {
        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: { search: this.searchString }
        });
        this.showSearchDropdown = false;
        this.$root.$emit('reload-table', 'freights');
      },
      getStocks() {
        this.$store.dispatch('stock/getStocks');
      }
    },
    created() {
      let status = this.$cookie.get('filterFreightByStatus');
      this.status = (status) ? status : 'all';
      let stock = this.$cookie.get('filterFreightByStock');
      this.stock = (stock) ? stock : 'all';
      if (this.$route.query.search) this.searchString = this.$route.query.search;
      this.getStocks();
    },
  }
</script>

<style>
  #search .freight-filter .md-input {
    color: #000;
    -webkit-text-fill-color: #000;
  }
  #search .line-flex{
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  #search .breack-btn{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// FreightSearchToolbar.vue?1f84912e